import { PivotConfig, ResultSet } from '@cubejs-client/core';

export enum CubeChartType {
  area = 'area',
  bar = 'bar',
  tinyBar = 'tinyBar',
  line = 'line',
  table = 'table',
}

export type CubeChartTypeUnion = keyof typeof CubeChartType;

type CubeChartFormatter = (value: any) => any;

export interface CubeChartFormatterConfig {
  x?: CubeChartFormatter;
  y?: CubeChartFormatter;
}

export interface CubeChartProps<TData extends Record<string, any> = any> {
  type: CubeChartTypeUnion;
  error: Error | null;
  isLoading: boolean;
  resultSet: ResultSet<TData> | null;
  pivotConfig?: PivotConfig;
  formatter?: CubeChartFormatterConfig;
}

export interface CubeChartBaseProps<TData extends Record<string, any> = any> {
  resultSet: ResultSet<TData>;
  pivotConfig?: PivotConfig;
  formatter?: CubeChartFormatterConfig;
}
